module.exports = __webpack_public_path__ + "media/images/icons/hand-0ab43fc04ee30fbac8294b5e3af4e670.svg";